module.exports = __webpack_public_path__ + "img/facepaint-4_en.39197b1.jpg";